import React from "react";

import Weather from "./Weather";

export default function App() {
  return (
    <div>
      <Weather defaultCity="Toronto" />
    </div>
  );
}
